export default {
  loading: true,
  errors: [],
  data: [],
}
